import { Component, Input, OnInit } from '@angular/core';
import {
  IBillingAccount,
  paymentService,
  PayButtonLevel,
} from '@dch/billing-business-logic';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import {
  EnvironmentService,
  LanguageService,
  TranslationService,
} from '@dch/ng-common';
import { Router } from '@angular/router';

import { ApplicationState } from 'src/app/state/reducers';
import { selectCustomerAccountState } from 'src/app/state/selectors/customer-account.selector';
import { selectTransactionsByAccountNumber } from 'src/app/state/selectors/billing-transactions.selectors';
import { selectPaymentInfoByAccountNumber } from 'src/app/state/selectors/billing-payment-info.selectors';
import { savePaymentDataRequest } from '../../../state/actions/payment.actions';
import { OVERVIEW_PAGE } from '../../config/my-bill.constants';
import { selectSelectedBillingAccount } from 'src/app/state/selectors/billing-balance.selector';
import { OnDestroyHookDirective } from '../../common/hooks/hook-ondestroy';

@Component({
  selector: 'my-bill-pay-button',
  templateUrl: './my-bill-pay-button.component.html',
  standalone: false,
})
export class MyBillPayButtonComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly selectCustomerAccountState$ = this.store.select(
    selectCustomerAccountState
  );
  readonly selectSelectedBillingAccount$ = this.store.select(
    selectSelectedBillingAccount
  );
  @Input() billingAccount: IBillingAccount;
  @Input() payButtonLevel: PayButtonLevel;
  @Input() openTransactionToPayIndex?: number;
  analyticsButtonZone: string;
  @Input() analyticsPageName?: string;
  @Input() documentReference?: number;
  @Input() isMobileView: boolean;
  @Input() hasClassTextRight = true;
  @Input() hasLeftPosition = false;
  @Input() payButtonText?: string;

  constructor(
    private store: Store<ApplicationState>,
    private router: Router,
    private environmentService: EnvironmentService,
    private translationService: TranslationService,
    private languageService: LanguageService
  ) {
    super();
  }

  ngOnInit() {
    this.analyticsButtonZone =
      this.analyticsPageName ?? `mybill.overview.${this.payButtonLevel}`;
  }

  onClick() {
    const transactions$ = this.store.select(
      selectTransactionsByAccountNumber(this.billingAccount.accountNumber)
    );
    const paymentInfo$ = this.store.select(
      selectPaymentInfoByAccountNumber(this.billingAccount.accountNumber)
    );

    this.addSubscription(
      combineLatest([
        transactions$,
        paymentInfo$,
        this.selectCustomerAccountState$,
        this.selectSelectedBillingAccount$,
      ]).subscribe(
        ([
          transactions,
          paymentInfoState,
          customerAccountState,
          selectedBillingAccount,
        ]) => {
          const isCurrentBillingAccountSelected =
            selectedBillingAccount &&
            selectedBillingAccount.accountNumber ===
              this.billingAccount.accountNumber;

          if (isCurrentBillingAccountSelected) {
            const openTransactions =
              transactions.result.openTransactions.billingDocuments;

            let redirectionUrl: string;

            if (this.environmentService.isProximusPlusMobileApp) {
              redirectionUrl =
                this.translationService.getTranslatedValueFor(
                  'bills.proximusplus.paymentRedirectionUrl'
                ) || 'myproximus://mybill/payment/close';

              redirectionUrl +=
                '?billingAccountNumber=' + this.billingAccount.accountNumber;
            } else {
              redirectionUrl =
                window.location.href.split(this.router.url)[0] + OVERVIEW_PAGE;

              redirectionUrl += '/fls/' + this.billingAccount.accountNumber;
            }

            const paymentDataRequestBody =
              paymentService.getPaymentDataRequestBody({
                openTransactions,
                payButtonLevel: this.payButtonLevel,
                openTransactionToPayIndex: this.openTransactionToPayIndex,
                selectedAccount: this.billingAccount,
                communication: paymentInfoState.result.structureCommunication,
                isUserSE: Boolean(customerAccountState.customerAccount?.isSE()),
                language: this.languageService.getSelectedLanguage(),
                acceptUrl: redirectionUrl,
                declineUrl: redirectionUrl,
              });

            this.store.dispatch(
              savePaymentDataRequest({
                requestBody: paymentDataRequestBody,
                billingAccountNumber: this.billingAccount.accountNumber,
              })
            );
          }
        }
      )
    );
  }
}
